var map = {
	"./logo-basic.svg": 101,
	"./logo-io.svg": 102,
	"./logo-simquadrat.svg": 103,
	"./logo-sipgate.svg": 8,
	"./logo-team.svg": 104,
	"./logo-trunking.svg": 105
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos ^\.\/logo\-.*\.svg$
// module id = 25
// module chunks = 0